import Vue from 'vue';
import Router from 'vue-router';

import MakeADecision from "./pages/MakeADecision";
import ProductivityMeditation from "@/pages/meditations/ProductivityMeditation";
import ProcrastinationMeditation from "@/pages/meditations/ProcrastinationMeditation";
import CreativityMeditation from "@/pages/meditations/CreativityMeditation";
import SelfLoveMeditation from "@/pages/meditations/SelfLoveMeditation";
import RelationshipsMeditation from "@/pages/meditations/RelationshipsMeditation";
import WeightLossMeditation from "@/pages/meditations/WeightLossMeditation";
import AfterBreakUpMeditation from "@/pages/meditations/AfterBreakUpMeditation";
import Grounding from "@/pages/Grounding";
import Coloring from "@/pages/Coloring";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/:token/makeADecision',
      name: 'makeADecision',
      component: MakeADecision,
      meta: {
        title: 'Make a decision'
      }
    },
    {
      path: '/:token/coloring',
      name: 'coloring',
      component: Coloring,
      meta: {
        title: 'Coloring'
      }
    },
    {
      path: '/:token/grounding',
      name: 'grounding',
      component: Grounding,
      meta: {
        title: 'Reboot your brain'
      }
    },
    {
      path: '/:token/productivityMeditation',
      name: 'productivityMeditation',
      component: ProductivityMeditation,
      meta: {
        title: 'Productivity Meditation'
      }
    },
    {
      path: '/:token/procrastinationMeditation',
      name: 'procrastionationMeditation',
      component: ProcrastinationMeditation,
      meta: {
        title: 'Procrastination Meditation'
      }
    },
    {
      path: '/:token/creativityMeditation',
      name: 'creativityMeditation',
      component: CreativityMeditation,
      meta: {
        title: 'Creativity Meditation'
      }
    },
    {
      path: '/:token/SelfLoveMeditation',
      name: 'selfLoveMeditation',
      component: SelfLoveMeditation,
      meta: {
        title: 'Self-love Meditation'
      }
    },
    {
      path: '/:token/RelationshipsMeditation',
      name: 'relationshipsMeditation',
      component: RelationshipsMeditation,
      meta: {
        title: 'Ideal Relationships Meditation'
      }
    },
    {
      path: '/:token/WeightLossMeditation',
      name: 'weightLossMeditation',
      component: WeightLossMeditation,
      meta: {
        title: 'Weight Loss Meditation'
      }
    },
    {
      path: '/:token/AfterBreakUpMeditation',
      name: 'afterBreakUpMeditation',
      component: AfterBreakUpMeditation,
      meta: {
        title: 'After Break-Up Meditation'
      }
    }
  ],
});
